// Which vendos may be linked to a data plan, and why one may not.
//
// A MikroTik always can (its hotspot cap has shipped for months). A Ruijie or
// OrangePi can only on hybrid router firmware 2.6.0 or newer, which caps each
// data session on the router itself; an older image cannot enforce a cap, so
// the server refuses the link — and this tells the operator the same thing
// BEFORE they try, naming the version the vendo runs and where to update it.

export const OPENWRT_DATA_CAP_MIN_FW = '2.6.0';

/** "2.6.0-abc123-prod" → "2.6.0". */
export const fwBase = (v?: string | null): string => (v ?? '').split('-')[0];

export const cmpVersion = (a: string, b: string): number => {
   const pa = (a || '').split('.').map((n) => parseInt(n, 10) || 0);
   const pb = (b || '').split('.').map((n) => parseInt(n, 10) || 0);
   const len = Math.max(pa.length, pb.length);
   for (let i = 0; i < len; i++) {
      const d = (pa[i] || 0) - (pb[i] || 0);
      if (d !== 0) return d > 0 ? 1 : -1;
   }
   return 0;
};

export interface DataPlanPickDevice {
   router?: { platform?: 'mikrotik' | 'openwrt'; firmwareVersion?: string } | null;
}

/** The reason this vendo cannot join a data plan, or null when it can. */
export function dataPlanPickBlock(d: DataPlanPickDevice): string | null {
   if (d.router?.platform !== 'openwrt') return null;
   const running = fwBase(d.router.firmwareVersion);
   if (running && cmpVersion(running, OPENWRT_DATA_CAP_MIN_FW) >= 0) return null;
   const shown = running ? `runs ${running}` : 'version not known yet';
   return `Needs router firmware ${OPENWRT_DATA_CAP_MIN_FW} or newer (${shown}). Update it from Device Settings → Updates.`;
}

/** True when this vendo sells only from its own allotment (a Ruijie / OrangePi). */
export function sellsFromOwnSlice(d: DataPlanPickDevice): boolean {
   return d.router?.platform === 'openwrt';
}
